<template>
  <v-card>
    <v-card-title class="headline">
      <span>
        {{title}}
        <span class="grey--text subheading" v-if="!!subText">{{subText}}</span>
      </span>
      <div class="grey--text subheading" v-if="!!subTitle">{{subTitle}}</div>
    </v-card-title>
    <v-card-text v-if="content">
      <slot name="content"></slot>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    subText: String,
    subTitle: String,
    content: Boolean
  }
};
</script>

<style>
</style>